export namespace PrintPdfModel {
    export interface IPrintPdfOptions {
        orientation?: "p" | "portrait" | "l" | "landscape";
        unit?: "pt" | "px" | "in" | "mm" | "cm" | "ex" | "em" | "pc";
        format?: string | number[];
        organizationName?: {
            x: number;
            y: number;
            fontSize: number
        };
        dateFromTo?: {
            x: number;
            y: number;
            fontSize: number;
            align?: "left" | "center" | "right" | "justify";
        };
        reportName?: {
            x: number;
            y: number;
            fontSize: number;
            align?: "left" | "center" | "right" | "justify";
        };
        autoTable?: {
            theme?: "striped" | "grid" | "plain" | null;
            startY?: number | false;
            showHead?: "everyPage" | "firstPage" | "never" | boolean;
            styles?: {
                minCellHeight?: number;
                cellWidth?: "auto" | "wrap" | number;
                font?: "helvetica" | "times" | "courier" | string;
                overflow: "linebreak" | "ellipsize" | "visible" | "hidden" | Function;
            },
            columnStyles?: {
                [key: string]: {
                    cellWidth?: "auto" | "wrap" | number;
                }
            }
        }
    }

    export class PrintPdfOptions implements IPrintPdfOptions {
        constructor(orientation?: "p" | "portrait" | "l" | "landscape",
            unit?: "pt" | "px" | "in" | "mm" | "cm" | "ex" | "em" | "pc",
            format?: string | number[],
            organizationName?: {
                x: number,
                y: number,
                fontSize: number
            },
            dateFromTo?: {
                x: number,
                y: number,
                fontSize: number,
                align?: "left" | "center" | "right" | "justify",
            },
            reportName?: {
                x: number,
                y: number,
                fontSize: number,
                align?: "left" | "center" | "right" | "justify",
            },
            autoTable?: {
                theme?: "striped" | "grid" | "plain" | null,
                startY?: number | false,
                showHead?: "everyPage" | "firstPage" | "never" | boolean,
                styles?: {
                    minCellHeight?: number,
                    cellWidth?: "auto" | "wrap" | number;
                    font?: "helvetica" | "times" | "courier" | string;
                    overflow: "linebreak" | "ellipsize" | "visible" | "hidden" | Function;
                },
                columnStyles?: {
                    [key: string]: {
                        cellWidth?: "auto" | "wrap" | number;
                    }
                }
            }) {
            this.orientation = orientation ?? this.orientation;
            this.unit = unit ?? this.unit
            this.format = format ?? this.format
            this.organizationName = organizationName ?? this.organizationName
            this.dateFromTo = dateFromTo ?? this.dateFromTo
            this.reportName = reportName ?? this.reportName
            this.autoTable = autoTable ?? this.autoTable
        };


        orientation?: "p" | "portrait" | "l" | "landscape" = "l";
        unit?: "pt" | "px" | "in" | "mm" | "cm" | "ex" | "em" | "pc" = "mm";
        format?: string | number[] = "a4";
        organizationName?: {
            x: number;
            y: number;
            fontSize: number
        } = {
                x: 13,
                y: 15,
                fontSize: 18
            };
        dateFromTo?: {
            x: number;
            y: number;
            fontSize: number;
            align?: "left" | "center" | "right" | "justify";
        } = {
                x: 282,
                y: 16,
                fontSize: 12,
                align: "right"
            };
        reportName?: {
            x: number;
            y: number;
            fontSize: number;
            align?: "left" | "center" | "right" | "justify";
        } = {
                x: 150,
                y: 25,
                fontSize: 14,
                align: "center"
            };
        autoTable?: {
            theme?: "striped" | "grid" | "plain" | null;
            startY?: number | false;
            showHead?: "everyPage" | "firstPage" | "never" | boolean;
            styles?: {
                minCellHeight?: number;
                cellWidth?: "auto" | "wrap" | number;
                font?: "helvetica" | "times" | "courier" | string;
                overflow: "linebreak" | "ellipsize" | "visible" | "hidden" | Function;
            },
            columnStyles?: {
                [key: string]: {
                    cellWidth?: "auto" | "wrap" | number;
                }
            }
        } = {
                theme: "grid",
                startY: 32,
                showHead: "everyPage",
                styles: {
                    minCellHeight: 8,
                    cellWidth: "wrap",
                    font: "Roboto-Regular",
                    overflow: "linebreak",
                },
                columnStyles: null
            };
    }
}
